import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { store } from '@Redux/store'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import i18n from '@Locale/index'
import { I18nextProvider } from 'react-i18next'
import { injectStore } from '@Api/Api'

injectStore(store)

ReactDOM.render(
	<React.StrictMode>
		<I18nextProvider i18n={i18n}>
			<BrowserRouter>
				<Provider store={store}>
					<App />
				</Provider>
			</BrowserRouter>
		</I18nextProvider>
	</React.StrictMode>,
	document.getElementById('root')
)

// register() could never succeed: react-scripts 4 only emits build/service-worker.js
// when src/service-worker.ts exists, and it never has here — so every load asked for
// a file that 404s and logged a registration error. unregister() rather than deleting
// the call outright, because it also clears any worker still registered on the origin
// from an older deployment; such a worker keeps serving its own cache forever and no
// deploy can dislodge it. It is deliberately not gated on NODE_ENV, so it cleans up
// localhost too.
serviceWorker.unregister()
